import { render, staticRenderFns } from "./ChatNode.vue?vue&type=template&id=30c1d061&scoped=true&"
import script from "./ChatNode.vue?vue&type=script&lang=js&"
export * from "./ChatNode.vue?vue&type=script&lang=js&"
import style0 from "./ChatNode.vue?vue&type=style&index=0&id=30c1d061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c1d061",
  null
  
)

export default component.exports